'use client'

import { Button } from '@vinted/web-ui'

import {
  HideAtBreakpoint,
  ShowAtBreakpoint,
} from '@marketplace-web/breakpoints/breakpoints-feature'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { getFingerprint } from '@marketplace-web/session-management/audit-util'
import {
  InfluencerInspirationModel,
  InfluencerLandingPageEvent,
  landingPageEvent,
} from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import SliderWrapper from '../../../../components/SliderWrapper/SliderWrapper'
import NewProductCard from '../ProductCard/NewProductCard'

type Props = { data: InfluencerInspirationModel }

export const NewInspirationSection = ({
  data: { title, description, ctaHeadline, ctaText, ctaUrl, productList },
}: Props) => {
  const { track } = useTracking()

  const handleOnCtaClick = async () =>
    track(
      landingPageEvent({
        event: InfluencerLandingPageEvent.ListItemCtaClick,
        targetDetails: ctaUrl,
        deviceId: await getFingerprint(),
      }),
    )

  return (
    <section data-testid="inspiration-section" className="influencer-v2__inspiration">
      <div className="influencer-v2__inspiration-main">
        <div className="influencer-v2__inspiration-main-content">
          <div className="influencer-v2__inspiration-column">
            <h3 className="influencer-v2__inspiration-title">{title}</h3>
            <div className="influencer-v2__inspiration-description">{description}</div>
            <HideAtBreakpoint breakpoint="wide">
              <div className="influencer-v2__inspiration-cards-wrapper">
                <SliderWrapper
                  childData={productList
                    .filter(card => card !== null)
                    .map((card, index) => ({
                      testId: `inspiration-section-product-card-${index}`,
                      ...card,
                    }))}
                  childComponent={NewProductCard}
                  nextButton={null}
                  previousButton={null}
                />
              </div>
            </HideAtBreakpoint>
          </div>

          <ShowAtBreakpoint breakpoint="wide">
            <div className="influencer-v2__inspiration-cards-wrapper">
              {productList.map((props, index) => {
                if (!props) return null

                return (
                  <NewProductCard
                    {...props}
                    key={index}
                    testId={`inspiration-section-product-card-${index}`}
                  />
                )
              })}
            </div>
          </ShowAtBreakpoint>
        </div>
      </div>
      <div className="influencer-v2__inspiration-bottom">
        <h3
          className="influencer-v2__inspiration-cta-headline"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: ctaHeadline }}
        />
        <div className="influencer-v2__inspiration-cta">
          <Button
            url={ctaUrl}
            styling={Button.Styling.Filled}
            inverse
            onClick={handleOnCtaClick}
            testId="inspiration-section-cta"
          >
            {ctaText}
          </Button>
        </div>
      </div>
    </section>
  )
}
